import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export async function patchValidationExtra(id, data) {
  return getAPIResponse(`/v1/validation/extra/${id}`, data, 'PATCH');
}